import { render, staticRenderFns } from "./userPasswordChange.vue?vue&type=template&id=1789d1fc&scoped=true&"
import script from "./userPasswordChange.vue?vue&type=script&lang=js&"
export * from "./userPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./userPasswordChange.vue?vue&type=style&index=0&id=1789d1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789d1fc",
  null
  
)

component.options.__file = "userPasswordChange.vue"
export default component.exports